import React from 'react';
import styled from 'styled-components';
import { LoginForm } from '../../features/auth';
import { Subtitle1 } from '../../shared/ui/Typography';
import BannerImg from './assets/banner.png';
import { Button } from '../../shared/ui';
import { ArrowLeftIcon } from '../../shared/ui/Button/icons';
import { BurgerMenu } from '../../widgets/BurgerMenu/ui/BurgerMenu';
import { useNavigate } from 'react-router-dom';
import { colors } from 'shared/styles/colors';

const LoginPageWrapper = styled.div`
    display: flex;
    height: 100vh;
    width: 100%;
    @media (max-width: 1024px) {

        justify-content: center;
    }
`;

const LeftPanel = styled.div`
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
    @media (max-width: 1024px) {
        display: none;
    }
`;


const BannerContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const BannerImageWrapper = styled.img`
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
`;

const RightPanel = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    padding: 40px;
    background-color: white;
    justify-self: center;
    @media (max-width: 1024px) {
        padding: 20px;
        max-width: 409px;
    }
`;


const FormContainer = styled.div`
    width: 100%;
    max-width: 409px;
    display: flex;
    flex-direction: column;
    gap: 36px;
`;

const LoginPage = () => {
  const navigate = useNavigate();
  return (
    <>

      <LoginPageWrapper>

        <LeftPanel>
          <BannerContainer>
            <BannerImageWrapper src={BannerImg} alt="banner"/>
          </BannerContainer>
        </LeftPanel>

        <RightPanel>
          <Button color={colors.accentSecondary} onClick={() => navigate('/')} startIcon={<ArrowLeftIcon/>} variant="secondary"> До головної сторінки</Button>


          <FormContainer>
            <Subtitle1>Увійти до системи</Subtitle1>
            <LoginForm/>
          </FormContainer>
          <div/>
        </RightPanel>
      </LoginPageWrapper>
    </>
  );
};

export default LoginPage;
